import React from 'react';
import { TableRow, TableCell, Typography, useTheme } from '@mui/material';
import {
  FolderShared,
  FolderSharedOutlined,
  UnfoldMoreOutlined,
} from '@mui/icons-material';
import { navRailBreakpoint } from '@theme/variables';
import { GroupToggle } from 'components/common/GroupToggle/GroupToggle';
import { projectRowStickyTop } from '../constants/sticky';

type Props = {
  name: string;
  count: number;
  onToggle: () => void;
  colSpan: number;
  collapsed: boolean;
  disabled: boolean;
};

export const ProjectToggleRow: React.FC<Props> = ({
  name,
  count,
  onToggle,
  colSpan,
  collapsed,
  disabled,
}) => {
  const theme = useTheme();

  return (
    <TableRow
      sx={{
        position: { xs: 'static', [navRailBreakpoint]: 'sticky' },
        top: projectRowStickyTop,
        zIndex: 50,
        '& > .MuiTableCell-root': {
          border: 'none',
          backgroundColor: 'white',
          paddingTop: 1,
          paddingBottom: 0,
          px: 0,
        },
      }}
    >
      <TableCell colSpan={colSpan}>
        <GroupToggle
          collapsed={collapsed}
          disabled={disabled}
          onClick={onToggle}
          sx={{
            gap: 1.5,
            backgroundColor: theme.palette.highlight.neutral,
            p: 1,
            pl: { xs: '16px', [navRailBreakpoint]: '12px' },
          }}
        >
          {collapsed ? (
            <FolderSharedOutlined sx={{ color: 'text.secondary' }} />
          ) : (
            <FolderShared sx={{ color: 'text.secondary' }} />
          )}
          <Typography component="span" variant="subtitle2">
            {name}
          </Typography>
          <Typography
            component="span"
            variant="subtitle2"
            color="text.secondary"
          >
            {count}
          </Typography>
          {collapsed && (
            <UnfoldMoreOutlined sx={{ color: 'text.disabled', fontSize: 16 }} />
          )}
        </GroupToggle>
      </TableCell>
    </TableRow>
  );
};
